import { instance } from '../config/api';

/**
 * @param {string} dataSource - e.g. 'transaction', 'settlement'
 * @param {string} from - ISO date string
 * @param {string} to - ISO date string
 * @returns {Promise<Blob>}
 */
const fetchReports = async (dataSource, from, to) => {
  const { data } = await instance.get(
    `${dataSource}/reports?from=${from}&to=${to}`,
    {},
    { responseType: 'blob' }
  );

  return data;
};

export { fetchReports };
